import React, { useEffect, useState, useRef } from 'react';
import _get from 'lodash.get';
import InfiniteScroll from 'react-infinite-scroll-component';

import PropTypes from 'prop-types';
import _isEqual from 'lodash.isequal';
import CardV2 from 'components_v2/common/CardV2/Card';
import WithStoryPriceTag from 'routes/toiplushome/hoc/WithStoryPriceTag';
import TOIPLoadingPlaceholder from 'components_v2/common/TOIPLoadingPlaceholder';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import {
  setPageConfigAndSendIBeatCall,
  setIbeattrack,
} from 'utils/iBeatConfig';
import { getPrcCookieValue } from 'utils/primeUtil';
import {
  debounce,
  getScrollPerPageDimensions,
  fireGaOnblur,
  removeFireGaOnblur,
  fireGA4Script,
  fireGA4WithDataObject,
} from 'utils/common';
import { connect } from 'react-redux';
import { loadNocData } from 'routes/toiplusnoc/redux';
import ToipNudges from 'components_v2/common/ToipNudges';
import { imageWidth } from 'routes/toiplussection/ToiplusSectionHelper';
import { UseIntersectionObeserver } from 'routes/home/layouts/India/context';
import { TOI_LIVE_DOMAIN } from '../../../../constants/index';
import './NocListing.scss';

const NocListing = props => {
  const {
    nocPageData,
    getToiplusNocData,
    params,
    userData,
    isWapView,
    nocTitle,
    paidStoriesMsid,
    priceTag,
    frmapp,
    urlPath,
  } = props;
  const [curpg, setCurpg] = useState(params.curpg);
  const gaTitle = nocTitle.replace(' ', '');
  const dimesnsionCurpgArr = useRef([]);
  const dimensionObj = useRef({});
  const currentCurpg = useRef(1);
  const getScrollEvent = () => {
    getScrollPerPageDimensions(
      '.toiplusnocpage',
      dimesnsionCurpgArr,
      dimensionObj,
    );

    console.log('dimensionObj.current', dimensionObj.current);
  };
  const sendScrollDepthGAEvent = () => {
    if (typeof window !== 'undefined') {
      analyticsWrapper(
        'ga',
        'send',
        'event',
        isWapView ? 'wap_scrolldepth_TOIPlus' : 'web_scrolldepth_TOIPlus',
        parseInt(dimensionObj.current[currentCurpg.current], 10) || 0,
        `${window.location.href}_page_${currentCurpg.current}`,
      );
    }
  };
  useEffect(
    () => {
      if (curpg > 1) {
        getToiplusNocData({ ...params, curpg });
        fireGA4WithDataObject(
          fireGA4Script({ isToipLayout: true, storyNumber: curpg - 1 }) || {},
        );
      }
      currentCurpg.current = curpg;
      window.addEventListener('scroll', debounce(getScrollEvent, 400));
      fireGaOnblur(sendScrollDepthGAEvent);
      return () => {
        window.removeEventListener('scroll', debounce(getScrollEvent, 400));
        removeFireGaOnblur(sendScrollDepthGAEvent);
      };
    },
    [curpg],
  );
  useEffect(
    () => {
      dimesnsionCurpgArr.current.push(`separator${currentCurpg.current}`);
    },
    [nocPageData],
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const pageViewUrl = `${TOI_LIVE_DOMAIN}${urlPath}`;
      analyticsWrapper('ga', 'send', 'pageview', pageViewUrl);
      fireGA4WithDataObject(
        fireGA4Script({ isToipLayout: true, storyNumber: 0 }) || {},
      );
      setIbeattrack({
        author: '',
        contentType: 20,
        msid: '',
        planStatus: getPrcCookieValue(),
        publishedDate: '',
      });
      setPageConfigAndSendIBeatCall();
    }
  }, []);

  if (!nocPageData || !nocPageData.length) {
    return null;
  }

  let componentReturned;
  return (
    nocPageData &&
    nocPageData.map((sectionItem = {}) => {
      switch (sectionItem.tn) {
        case 'toipnudge': {
          componentReturned = isWapView && (
            <ToipNudges
              viewType="toiplusnocpage"
              isWapView={isWapView}
              userData={userData}
              frmapp={frmapp}
            />
          );
          break;
        }
        case 'H1tag': {
          componentReturned = isWapView &&
            nocTitle && <h1 className="toiplusHeading">{nocTitle} Stories</h1>;
          break;
        }
        case 'sectionlisting': {
          componentReturned = (
            <InfiniteScroll
              dataLength={sectionItem.items.length}
              next={() => setCurpg(prevCurpg => prevCurpg + 1)}
              hasMore={sectionItem.pagination?.hm}
              scrollThreshold={1}
              loader={TOIPLoadingPlaceholder()}
            >
              {Array.isArray(sectionItem.items) &&
                sectionItem.items.length &&
                sectionItem.items.map((item, cardindex) => {
                  switch (item.tn) {
                    case 'toipnudge': {
                      componentReturned = (
                        <ToipNudges
                          viewType="toiplusnocpage"
                          isWapView={isWapView}
                          userData={userData}
                          frmapp={frmapp}
                        />
                      );
                      break;
                    }
                    case 'separator': {
                      componentReturned = (
                        <div
                          data-separator={item.curpg}
                          id={`separator${item.curpg}`}
                        />
                      );
                      break;
                    }
                    default: {
                      componentReturned = (
                        <UseIntersectionObeserver.Provider value>
                          <CardV2
                            key={cardindex}
                            data={item}
                            showNocName
                            isVerticalTile
                            timeStampHtml
                            imgWidth={imageWidth(
                              item.isLead === 'featured',
                              isWapView,
                            )}
                            istoipListing
                            showDescription={!isWapView}
                            gaPageName={`TOIPlus_NOC_${gaTitle}`}
                            userData={userData}
                            isWapView={isWapView}
                            tpPageName="noc"
                            paidStoriesMsid={paidStoriesMsid}
                            priceTag={priceTag?.h1}
                            shouldNotlazyloadImage={
                              item.isLead === 'featured' ||
                              item.isSubLead === 'subfeatured'
                            }
                          />
                        </UseIntersectionObeserver.Provider>
                      );
                    }
                  }
                  return componentReturned;
                })}
            </InfiniteScroll>
          );
          break;
        }
        default: {
          componentReturned = null;
        }
      }
      return componentReturned;
    })
  );
};

const mapDispatchToProps = dispatch => ({
  getToiplusNocData: curpg => {
    dispatch(loadNocData(curpg));
  },
});
const cachedResultIfPresent = (function getCachedResultIfAvailable() {
  let cachedData = { geo: {}, userData: {} };
  return data => {
    if (!_isEqual(cachedData, data)) {
      cachedData = data;
    }

    return cachedData;
  };
})();
const mapStateToProps = state => ({
  geo: cachedResultIfPresent({
    userData: _get(state, 'login.userData', {}),
    geo: _get(state, 'geo', null),
  })?.geo,
  nocPageData: _get(state.toiplusnoc, 'sections', []),
  userData: cachedResultIfPresent({
    userData: _get(state, 'login.userData', {}),
    geo: _get(state, 'geo', null),
  })?.userData,
});

NocListing.propTypes = {
  nocPageData: PropTypes.arrayOf(
    PropTypes.shape({
      tn: PropTypes.string,
      pagination: PropTypes.objectOf(PropTypes.number),
      items: PropTypes.arrayOf(PropTypes.string),
    }),
  ),
  getToiplusNocData: PropTypes.func.isRequired,
  userData: PropTypes.shape({}),
  isWapView: PropTypes.bool,
  nocTitle: PropTypes.string,
  paidStoriesMsid: PropTypes.arrayOf(PropTypes.string),
  priceTag: PropTypes.shape({}),
  frmapp: PropTypes.bool,
  urlPath: PropTypes.string,
};

NocListing.defaultProps = {
  nocPageData: [],
  isWapView: false,
  nocTitle: '',
  paidStoriesMsid: [],
  priceTag: {},
  userData: undefined,
  frmapp: false,
  urlPath: '',
};

export default WithStoryPriceTag(
  connect(mapStateToProps, mapDispatchToProps)(NocListing),
);
